import { Component, OnInit } from '@angular/core';
import {
  Chart,
  ChartConfiguration,
  ChartData,
  CategoryScale,
  LinearScale,
  BarController,
  BarElement,
} from 'chart.js';
import { LogAnalyticsService } from '../../services/log-analytics.service';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { BaseChartDirective } from 'ng2-charts';
import { MatProgressBar } from '@angular/material/progress-bar';
// Register the required Chart.js components
Chart.register(CategoryScale, LinearScale, BarController, BarElement);

@Component({
  selector: 'app-la-alerts-by-team',
  templateUrl: './la-alerts-by-team.component.html',
  styleUrls: ['./la-alerts-by-team.component.scss'],
  standalone: true,
  imports: [MatProgressSpinnerModule, MatIconModule, BaseChartDirective, MatProgressBar],
})
export class LaAlertsByTeamComponent implements OnInit {
  isLoading = false;

  barChartData: ChartData<'bar'> = {
    labels: [],
    datasets: [],
  };

  barChartOptions: ChartConfiguration<'bar'>['options'] = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
        position: 'top',
      },
      title: {
        display: true,
        text: 'Alerts By Team - Last 30 Days',
        align: 'center',
        font: {
          size: 16,
        },
      },
    },
    indexAxis: 'x',
    scales: {
      x: {
        type: 'category',
        stacked: true,
        display: true,
        title: {
          display: true,
          text: 'Teams',
        },
      },
      y: {
        type: 'linear',
        stacked: true,
        display: true,
        beginAtZero: true,
        title: {
          display: true,
          text: 'Count',
        },
      },
    },
  };

  constructor(private readonly logAnalyticsService: LogAnalyticsService) {}

  ngOnInit(): void {
    this.loadAlertData();
  }

  private loadAlertData(): void {
    this.isLoading = true;
    this.logAnalyticsService.queryAlertsByTeam().subscribe({
      next: (result) => {
        // Get unique teams and sort them alphabetically
        const teams = [...new Set(result.tables[0].rows.map((row) => row[0]))].sort();
        const alerts = [...new Set(result.tables[0].rows.map((row) => row[1]))];

        this.barChartData = {
          labels: teams,
          datasets: alerts.map((alert) => ({
            label: alert,
            data: teams.map((team) => {
              const match = result.tables[0].rows.find(
                (row) => row[0] === team && row[1] === alert
              );
              return match ? match[2] : 0;
            }),
          })),
        };
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading alert data:', error);
        this.isLoading = false;
      },
    });
  }
}
